import assert from 'assert'


const getClientAuthorization = () => {
  return `Basic ${base64EncodeOAuthCredentials(process.env.EBAY_CLIENT_ID, process.env.EBAY_CLIENT_SECRET)}`
}

const getAaccessTokenAuthorization = userAccessToken => {
  return `Bearer ${userAccessToken}`
}

const base64EncodeOAuthCredentials = (clientId, clientSecret) => {
  const data = `${clientId}:${clientSecret}`
  return Buffer.from(data, 'utf8').toString('base64')
}

export {
  getClientAuthorization,
  getAaccessTokenAuthorization
}

assert(process.env.EBAY_CLIENT_ID, `Please specify the ebay developer account client id (EBAY_CLIENT_ID). 
  
This is part of the applications key set: https://developer.ebay.com/my/keys`)
assert(process.env.EBAY_CLIENT_SECRET, `Please specify the ebay developer account client secret (EBAY_CLIENT_SECRET)

This is part of the application key set: https://developer.ebay.com/my/keys`)
